export default __webpack_public_path__ + "static/media/favicon.b1806f5f.png";